var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutlineCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#176F69",
  strokeWidth: 1.1,
  d: "M1.217 8.5A6.79 6.79 0 0 1 8 1.717 6.79 6.79 0 0 1 14.783 8.5 6.79 6.79 0 0 1 8 15.283 6.79 6.79 0 0 1 1.217 8.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  d: "M5.376 8.657a.55.55 0 0 0-.752.803zm1.783 2.425-.377.401a.55.55 0 0 0 .795-.044zm4.256-4.14a.55.55 0 0 0-.837-.714zM4.624 9.46l2.158 2.023.753-.802-2.159-2.024zm2.953 1.979 3.838-4.497-.837-.714-3.838 4.497z"
})));
export { SvgOutlineCheck as ReactComponent };